import { createFileRoute } from "@tanstack/react-router";

import { HubIndexPage, hubQuery } from "@/components/hubs/HubIndexPage";
import { hubIndexHead } from "@/lib/hub-seo";

const PATH = "/restaurants";

export const Route = createFileRoute("/restaurants/")({
  loader: ({ context }) => context.queryClient.ensureQueryData(hubQuery("restaurants")),
  head: ({ loaderData }) =>
    hubIndexHead({
      path: PATH,
      locale: "en",
      loaderData,
      fallbackTitle: 'Restaurants in Finland — cuisine, prices, opening hours | what Finland',
      fallbackDescription: 'Browse Finnish restaurants by cuisine, price range and region, with opening hours and menus.',
      listName: 'Restaurants in Finland',
    }),
  component: () => <HubIndexPage slug="restaurants" locale="en" />,
});
